<template>
  <div id="PriceFunFood">
    <div data-html2canvas-ignore="true" v-show="loader">
      <Loader />
    </div>
    <div class="datepickerwrap row card" style="flex-direction: row; justify-content: space-between;">
      <div style="display: flex">
        <div class="mr-2">
          <div class="mb-1" style="font-size:14px; font-weight:400; color:rgba(30, 30, 30, 1)">Date Range</div>
          <date-range-picker v-model="dateRange" opens='right' :autoApply="true"
            :locale-data="{ format: 'dd mmm yyyy' }" :min-date="minDate" :max-date="maxDate">
          </date-range-picker>
        </div>
        <div class="customSelect">
          <div class="mb-1" style="font-size:14px; font-weight:400; color:rgba(30, 30, 30, 1)">Platform</div>
          <select v-model="selectedPlatform" @change="changePlatform" class="form-control text-uppercase">
            <option v-for="website of viewPlatformAndCategoryData.platform" :value="website"
              :key="website.platform_name">{{ website.platform_name }}</option>
          </select>
        </div>
        <div class="customSelect">
          <div class="mb-1" style="font-size:14px; font-weight:400; color:rgba(30, 30, 30, 1)">Category</div>
          <select v-model="selectedCat" @change="changeCat" class="form-control text-uppercase">
            <option v-for="category of catOptions" :key="category.key" :value="category">
              {{ category.value }}
            </option>
          </select>
        </div>

        <div class="datebox" style="width: 18%" v-if="selectedCat.priceBand">
          <div class="mb-1" style="font-size:14px; font-weight:400; color:rgba(30, 30, 30, 1)">Price Band</div>
          <select v-model="selectedPriceBand" @change="changePriceBand" class="form-control text-uppercase">
            <option v-for="priceBandValue, priceBandLabel of selectedCat.priceBand" :value="priceBandValue"
              :key="priceBandLabel + priceBandValue">{{ priceBandLabel }}</option>
          </select>
        </div>
      </div>
      <div class="d-flex">
        <div class="customSelect mt-4" v-if="customInterval">
          <input v-model="selectedInterval" type="number" class="form-control text-uppercase" />
        </div>
        <div class="customSelect" v-else-if="intervals.length">
          <div class="mb-1" style="font-size:14px; font-weight:400; color:rgba(30, 30, 30, 1)">Price</div>
          <select v-model="selectedInterval" class="form-control text-uppercase">
            <option v-for="interval of intervals" :key="interval" :value="interval">
              {{ selectedPlatform.platform_currency.toLowerCase() !== 'usd' ? selectedPlatform.platform_currency + " " +
                interval : interval + " " + selectedPlatform.platform_currency }}</option>
          </select>
        </div>
        <!-- <div class="mt-4">
          <button @click="getPriceData" class="btn primarycolor mr-2" type="button" v-if="customInterval">
            <span>Submit</span>
          </button>
        </div> -->
        <div class="mt-4">
          <button @click="toggleCustomInterval" class="btn primarycolor" type="button">
            <span>{{ customInterval ? 'Default' : 'Custom' }}</span>
          </button>
        </div>
        <div class="mt-4 ml-2">
          <button @click="handleApplyFilter" class="btn primarycolor" type="button">
            <span>Apply Filter</span>
          </button>
        </div>
        <!-- <div class="lastUpdated ml-2">
          Last Updated: {{ lastUpdated }}
        </div> -->
      </div>
      <!-- <div class="col-2">
        <input
          class="form-control"
          type="text"
          @keyup="searchProduct"
          v-model="schKey"
          placeholder="Search"
        />
      </div> -->
    </div>
    <div class="card" style="margin-inline: 10px;">
      <highcharts :options="priceChart"></highcharts>
      <highcharts :options="priceTrendLine"></highcharts>
    </div>
  </div>
  <!-- <div class="flex ml-2 mr-4">
      <div class="">
        <b-row v-for="(od, oi) in data" :key="'product_price_' + oi">
          <b-col sm="12" lg="12">
            <b-row class="">
              <div
                class="col-6 pr-xl-0"
                v-for="(pd, pi) in od"
                :key="'compTimelines_' + oi + '_' + pd.product_name + '_' + pi"
              >
                <div class="card">
                  <h5 :title="pd.product_name" class="graphHeading">
                    {{ pd.product_name.toUpperCase() }}
                  </h5>
                  <div style="">
                    <div
                      style="width: 100% !important"
                      :class="{ chartOverflow: od.length > 1 }"
                    >
                      <highcharts
                        :options="
                          chartData['compChart_' + oi + '_' + pd.product_name + '_' + pi]
                        "
                      ></highcharts>
                    </div>
                  </div>
                </div>
              </div>
            </b-row>
            <b-row
              v-for="(pd, pi) in od"
              class="card ml-1"
              :key="'compSummary_' + oi + '_' + pd.product_name + '_' + pi"
            >
              <div class="col-sm-12 pl-0">
                <h5 class="graphHeading" style="margin-bottom: 0px">
                  {{ pd.product_name.toUpperCase() }}
                </h5>
              </div>
              <div class="borderBetween"></div>
              <b-row style="margin-bottom: -20px">
                <b-col
                  :class="{ 'col-sm-2': selectedPlatform }"
                  style=""
                  v-for="d in pd.platform_data"
                  :key="d.platform + oi"
                >
                  <div style="border: none" :class="d.platform + '_border'">
                    <div class="rightsticker">
                      <div class="name">
                        <img style="width: 19px" :src="'/img/' + d.platform + '.png'" />
                        <a v-if="d.link" target="_blank" :href="d.link">
                          {{ d.platform }}
                        </a>
                        <span v-else> {{ d.platform }} </span>
                      </div>
                      <div class="value" :style="'color:' + platformColor[d.platform]">
                        <i
                          class="fa fa-rupee"
                          v-if="
                            (d.discount_price && d.discount_price != 'N/A' && d.link) ||
                            (d.original_price && d.original_price != 'N/A')
                          "
                        ></i>
                        <span v-if="d.discount_price && d.discount_price !== 'N/A'">
                          {{ formatNumber(d.discount_price) }}</span
                        >
                        <span v-if="!d.discount_price && d.original_price">
                          {{ formatNumber(d.original_price) }}</span
                        >
                        <span v-if="d.quantity"> ({{ d.quantity }})</span>
                        <div class="outofstock" v-if="d.not_available">Not Available</div>
                        <div class="outofstock" v-if="!d.not_available && d.out_of_stock">
                          Out of stock
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </div> -->
</div></template>
<script src="http://code.highcharts.com/11/highcharts.js"></script>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Loader from "../Components/Loader.vue"
export default {
  name: "PriceGlobalDemo",
  components: {
    Datepicker,
    Loader
  },
  data: function () {
    return {
      data: {},
      moment: moment,
      seriesDataFiltered: [],
      timestamp: moment().subtract(7, "days").format("YYYY-MM-DD"),
      timestamp2: moment().subtract(1, "day").format("YYYY-MM-DD"),
      dateRange: {
        startDate: moment().subtract(1, 'week').format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(1, 'month')),
      timestamp1Disabled: {
        to: "",
        from: "",
      },
      timestamp2Disabled: {
        to: "",
        from: "",
      },
      catOptions: ['saree', 'kurti'],
      loader: false,
      selectedCat: "",
      schKey: "",
      dataFull: {},
      chartData: [],
      selectedPlatform: '',
      platformColor: {
        // flipkart: "#2874f0",
        amazon: "#FF9900",

      },
      customClient: JSON.parse(localStorage.reviewUserData).data.client,
      priceChart: {},
      intervals: [],
      selectedInterval: null,
      tempSelectedInterval: "",
      customInterval: false,
      priceTrendLine: {},
      categories: {
        "amazon us": ["multivitamins"],
        "amazon sa": ["multivitamins", "beauty", "home furnishing", "home appliances", "home decorations", "luggage"]
      },
      viewPlatformAndCategoryData: "",
      selectedPriceBand: "",
      disabledDates: {
        to: "",
        from: new Date()
      },
      brandCounts: {},
      lastUpdated: `${moment().format("YYYY-MM-DD")} 11:00 AM`,
    };
  },
  created() {
    if(this.customClient === 'global_demo') {
      this.viewPlatformAndCategoryData = JSON.parse(localStorage.viewPlatformAndCategoryData);
      if(localStorage.selected_website) {
        this.viewPlatformAndCategoryData.platform.forEach(platform => {
          if(platform.platform_link === localStorage.selected_website) {
            this.selectedPlatform = platform;
          }
        })
      } else this.selectedPlatform = this.viewPlatformAndCategoryData.platform[0];
      
      this.catOptions = this.viewPlatformAndCategoryData.category[this.selectedPlatform.platform_name];
      
      if(localStorage.demo_selectedItemCategory) {
        this.selectedCat = JSON.parse(localStorage.demo_selectedItemCategory)
      } else this.selectedCat = this.catOptions[0];
  
      if (localStorage.selected_price_band) {
          this.selectedPriceBand = localStorage.selected_price_band;
        } else {
          if (this.selectedCat.priceBand) {
            Object.values(this.selectedCat.priceBand).forEach((priceVal, index) => {
              if (index === 0) this.selectedPriceBand = priceVal
            })
          } else this.selectedPriceBand = "";
          localStorage.selected_price_band = this.selectedPriceBand;
        };
    }
    
  },
  mounted() {
      this.getLastUpdatedDates();
      this.selectedInterval = localStorage.defaultInterval
      // if(this.customClient !== 'global_demo') {
      //   this.getNavbarCategories();
      // } else {
      //   this.refresh();
      // }
  },
  methods: {
    toggleCustomInterval() {
      this.customInterval = !this.customInterval;
      if (!this.customInterval) {
        this.selectedInterval = localStorage.defaultInterval;
      }
    },
    handleApplyFilter(){
        // this.changePlatform();
        // this.changeCat();
        // this.changePriceBand();
        this.getPriceData();
        // this.refresh();
      
    },
    changePriceBand() {
      localStorage.selected_price_band = this.selectedPriceBand;
      // this.selectedInterval = "";
      // this.getPriceData()
    },
    changePlatform() {
      this.catOptions = this.viewPlatformAndCategoryData.category[this.selectedPlatform.platform_name];
      this.selectedCat = this.catOptions[0];
      
      localStorage.selected_website = this.selectedPlatform.platform_link;
      localStorage.demo_selectedItemCategory = JSON.stringify(this.selectedCat)
      
      this.$nextTick(() => {
        if (this.selectedCat.priceBand) {
          Object.values(this.selectedCat.priceBand).forEach((priceVal, index) => {
            if (index === 0) this.selectedPriceBand = priceVal
          })
        } else this.selectedPriceBand = "";
        localStorage.selected_price_band = this.selectedPriceBand;
        // this.selectedInterval = "";
        // this.getPriceData();
      });

      
    },
    changeCat() {
      localStorage.demo_selectedItemCategory = JSON.stringify(this.selectedCat)
      
      this.$nextTick(() => {
        if (this.selectedCat.priceBand) {
          Object.values(this.selectedCat.priceBand).forEach((priceVal, index) => {
            if (index === 0) this.selectedPriceBand = priceVal
          })
        } else this.selectedPriceBand = "";
        localStorage.selected_price_band = this.selectedPriceBand;
        // this.selectedInterval = "";
        // this.getPriceData();
      });

      
    },
    updateDisabledDates() {
      this.timestamp1Disabled = {
        to: moment("2022-09-10", "YYYY-MM-DD").toDate(),
        from: moment(this.timestamp2, "YYYY-MM-DD").toDate(),
      };
      this.timestamp2Disabled = {
        to: moment(this.timestamp, "YYYY-MM-DD").toDate(),
        from: moment().subtract(1, "day").toDate(),
      };
    },
    getChartWidth(compCount) {
      if (compCount == 1) return "width:100%";
      let diff = moment(this.dateRange.endDate).diff(moment(this.dateRange.startDate), "days");
      if (diff < 4) return "width:100%";
      let width = diff * 100;
      return "width:" + width + "px";
    },
    formatNumber(n) {
      if (n && !isNaN(n)) {
        return Number(n).toLocaleString();
      } else {
        return n;
      }
    },
    searchProduct() {
      let self = this;
      this.loader = true;

      setTimeout(function () {
        self.data = {};
        for (let [idx, ds] of Object.entries(self.dataFull)) {
          if (idx.toLowerCase().includes(self.schKey.toLowerCase())) {
            self.data[idx] = ds;
          }
        }
        self.loader = false;
      }, 0);
    },
    processChart() {
      let self = this;
      for (let [idx, ds] of Object.entries(this.data)) {
        for (let [idx2, ds2] of ds.entries()) {
          let chartKey = "compChart_" + idx + "_" + ds2.product_name + "_" + idx2;
          self.createChart(ds2.timeline, chartKey);
        }
      }
    },
    removeEmptySeries() {
      let self = this;
      for (let [i, d] of self.seriesDataFiltered.entries()) {
        var hasData = false;
        for (let [idx, ds] of d.data.entries()) {
          if (ds.toString().length) {
            hasData = true;
          }
        }
        if (!hasData) {
          self.seriesDataFiltered.splice(i, 1);
          this.removeEmptySeries();
        }
        if (i == self.seriesDataFiltered.length - 1) return;
      }
    },
    createChart(timeline, key) {
      let self = this;
      let xaxis = [];
      self.seriesDataFiltered = [];
      let seriesData = [];
      for (let [idx, ds] of timeline.entries()) {
        xaxis.push(moment(ds.date).format("DD MMM YYYY"));
        for (let [idx2, ds2] of ds.price.entries()) {
          if (idx == 0) {
            seriesData.push({
              name: ds2.name.toUpperCase(),
              data: [ds2.value],
              color: self.platformColor[ds2.name],
            });
          } else {
            for (let [idx3, ds3] of seriesData.entries())
              if (ds3.name == ds2.name.toUpperCase()) ds3.data.push(ds2.value);
          }
        }
      }
      if (self.selectedPlatform.platform_name) {
        for (let [idx2, ds2] of seriesData.entries()) {
          if (self.selectedPlatform.platform_name.toUpperCase() == ds2.name) {
            self.seriesDataFiltered.push(ds2);
          }
        }
      } else {
        self.seriesDataFiltered = seriesData;
      }
      this.removeEmptySeries();
      let obj = {};
      self.chartData[key] = {
        chart: {
          type: "line",
          height: 180,
          marginBottom: 50,
          marginTop: 20,
        },
        title: {
          text: "",
        },
        subtitle: {
          verticalAlign: "bottom",
          text: "",
        },
        xAxis: {
          tickmarkPlacement: "on",
          categories: xaxis,
          title: { text: "" },
          gridLineWidth: 1,
          labels: {
            rotation: 0,
            style: { fontSize: 10, textOverflow: "none" },
          },
        },
        plotOptions: {
          line: {
            marker: {
              radius: 3,
            },
            dataLabels: {
              enabled: true,
              allowOverlap: true,
              style: { fontWeight: 0 },
              formatter: function () {
                return "₹" + this.point.y.toLocaleString();
              },
            },
          },
        },
        yAxis: {
          title: {
            text: "Price(₹)",
            margin: 25,
            style: {
              color: "#065559",
            },
          },
        },
        tooltip: {
          formatter: function () {
            for (var i = 0; i < this.points.length; i++) {
              mytooltip += '<span style="color:' + this.points[i].color + '">● </span>';
              mytooltip += this.points[i].series.name;
              mytooltip += ":<b> ₹" + self.formatNumber(this.points[i].y) + "</b><br/>";
            }
            return mytooltip;
          },
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        legend: {
          enabled: true,
          alignColumns: true,
          align: "left",
          itemDistance: 12,
          marginTop: 10,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
          itemStyle: {
            fontSize: "10px",
          },
        },
        credits: {
          enabled: false,
        },
        series: self.seriesDataFiltered,
      };
    },
    getLastUpdatedDates() {
      this.loader = true;

      const url = `/api/v2/india_clients/last_update?client=${this.customClient}`;
      this.$http.get(url).then(
        (response) => {
          if (response.body.data.market_explorer) {
            localStorage.market_explorer_last_update = JSON.stringify(response.body.data.market_explorer);
            this.dateRange.endDate = moment(response.body.data.market_explorer.end_date).format("YYYY-MM-DD");
            this.dateRange.startDate = moment(response.body.data.market_explorer.end_date).subtract(1, 'week').format("YYYY-MM-DD");
            this.maxDate = new Date(response.body.data.market_explorer.end_date);
            this.minDate = new Date(response.body.data.market_explorer.start_date);
            this.lastUpdated = `${moment(response.body.data.market_explorer.end_date).format("DD MMM, YYYY")} ${response.body.data.market_explorer.latest_time?"at":""} ${response.body.data.market_explorer.latest_time}`;
            this.$store.dispatch('DemoStore/setTimeStamp', this.lastUpdated);

          }
          this.loader0 = false;
          if(this.customClient !== 'global_demo') {
            this.getNavbarCategories();
          } else {
            this.refresh();
          }
        },
        (err) => {
          this.loader0 = false;
          if(this.customClient !== 'global_demo') {
            this.getNavbarCategories();
          } else {
            this.refresh();
          }
          console.log("err");
        }
      );
    },
    getNavbarCategories() {
      this.loader = true;
      const url = "/api/v2/global_demo/navbar_categories";
      const payload = {
        client: this.customClient,
      };

      this.$http.post(url, payload).then(
        (response) => {
          this.viewPlatformAndCategoryData = response.data.data;
          if (response.data.data.platform) {
            this.selectedPlatform = this.viewPlatformAndCategoryData.platform[0];
      
            this.catOptions = this.viewPlatformAndCategoryData.category[this.selectedPlatform.platform_name];
            this.selectedCat = this.catOptions[0];
            if (this.selectedCat.priceBand) {
            Object.values(this.selectedCat.priceBand).forEach((priceVal, index) => {
              if (index === 0) this.selectedPriceBand = priceVal
            })
          } else this.selectedPriceBand = "";
            // this.selected_website = response.data.data.platform[0].platform_link;
            // for (let link of response.data.data.platform) {
            //   this.websitesUrls[link.platform_link] = link.platform_name
            // }
          }
          // localStorage.selected_website = this.selected_website;
          this.$nextTick(() => {
            this.getPriceData();
            // this.refresh();
            // this.changeWebsiteCategorySet("firstRender");
          })
          this.loader = false;
        },
        (err) => {
          this.loader = false;
        }
      );
    },
    getPriceData() {
      let self = this;
      let url = "/api/v2/global_demo/product_price";
      this.loader = true;
      this.data = {};
      this.dataFull = {};
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        item_category: this.selectedCat.key,
        client: self.customClient,
        brand_size: 5,
        website: this.selectedPlatform.platform_link,
      };

      if(this.selectedInterval) {
        payload["interval"] = this.selectedInterval.toString();
      }

      if(this.selectedPriceBand) {
        payload["price_band"] = this.selectedPriceBand;
      }

      this.$http
        .post(url, payload)
        .then((response) => {
          this.loader = false;
          this.brandCounts = response.data.all_brands_dict;
          this.processPriceChart(response.data.data)
          this.drawTrendline(response.data.data)
          this.intervals = response.data.intervals;
          this.selectedInterval = response.data.selected_interval;
          this.tempSelectedInterval = response.data.selected_interval;
          if(!this.customInterval) localStorage.defaultInterval = this.selectedInterval;
        })
        .catch((err) => {
          this.loader = false;
        });
    },
    drawTrendline(d) {
      let self = this;
      let categories = [];
      let seriesData = [
        {
          name: "Product Count",
          data: []
        }
      ];

      for (let dataset of d) {
        categories.push(dataset.interval);
        seriesData[0].data.push(dataset.total_count)
      }

      self.priceTrendLine = {
        chart: {
          type: "line",
          height: 300,
          marginTop: 60,
          marginBottom: 100
        },
        title: {
          text: "",
        },
        
        xAxis: {
          categories: categories,
          crosshair: {
            width: 70,
          },
          title: {
            text: "Price Range" + " (in " + self.selectedPlatform.platform_currency + ")",
            style: {
              color: "#47A694",
              fontSize: "14px",
              fontWeight: "bold"
            }
          }
        },
        // plotOptions: {
        //   line: {
        //     dataLabels: {
        //       enabled: true,
        //       style: { fontWeight: 0 },
        //       formatter: function () {
        //         let category = this.point.category;
        //         let plotY = this.point.plotY;
        //         if (obj.hasOwnProperty(category)) obj[category].push(plotY);
        //         else {
        //           obj[category] = [];
        //           obj[category].push(plotY);
        //         }
        //         let plotYPos = obj[category].indexOf(plotY);
        //         let prvPlotY = obj[category][plotYPos - 1];
        //         if (plotYPos > 0) {
        //           if (plotY - prvPlotY < 9 && plotY - prvPlotY > -9) {
        //             this.point.plotY = this.point.plotY + 9;
        //             obj[category][plotYPos] = this.point.plotY;
        //           }
        //         }
        //         return this.point.y + "%";
        //       },
        //     },
        //   },
        // },
        yAxis: { 
          title: {
            text: "Product Count",
            style: {
              color: "#47A694",
              fontSize: "14px",
              fontWeight: "bold"
            }
          }, 
        },
        tooltip: {
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
          // formatter: function () {
          //   return "<b>"+ this.points[0].series.name + "</b>" + "<br/>" + "Products" + ": " + this.points[0].point.options.count
          // }
        },
        legend: {
          enabled: true,
          alignColumns: true,
          align: "right",
          y: 0,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
        },
        credits: { enabled: false },
        series: [
          {
            name: seriesData[0].name,
            data: seriesData[0].data,
            color: "#76999A",
            // tooltip: { valueSuffix: " %" },
            marker: {
              radius: 3,
              states: {
                hover: {
                  radiusPlus: 2,
                  lineWidthPlus: 1,
                },
              },
            },
          }
        ],
      };
    },
    processPriceChart(d) {
      let self = this;
      let seriesData = [];
      let xAxisData = [];
      let stacks = [];
      let counts = [];


      // let minPointLength = 0;
      let color = ["#76999A", "#A59AF0", "#8CE2B6", "#8B8D94", "#ACC1B5", "#8C9BFF", "#C4BBF6", "#81C1B8", "#75A49E", "#ddc7f8", "#44777A", "#46877D", "#FDC256", "#62D99C", "#666872", "#667BFE", "#F8A2BF", "#DECC5A", "#D0C1C3", "#68D6C9", "#0EBA9A", "#70819B"];

      /* Mapping categories */
      for (const chartData of d) {
        xAxisData.push(chartData.interval)
        counts.push(chartData.total_count)
        Object.values(chartData.brands_data).forEach(series => {
          if (!stacks.includes(series.brand)) {
            stacks.push(series.brand)
          }
        });
      }

      stacks.sort().forEach((stack, idx) => {
        let obj = {
          name: stack,
          data: new Array(d.length).fill(null),
          color: color[idx],
          borderWidth: 0,
        };

        for (const chartData of d) {
          Object.values(chartData.brands_data).forEach(series => {
            let index = xAxisData.indexOf(chartData.interval  )
            if (series.brand === stack) {
              obj.data[index] = {
                y: series.value,
                tooltip: series.tooltip
              }
            }
          });
        }
        seriesData.push(obj);
      })

      self.priceChart = {
        chart: {
          type: "column",
          height: 600,
          // marginTop: 120,
          // marginBottom: 40,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: xAxisData,
          title: {
            text: "Price Range" + " (in " + self.selectedPlatform.platform_currency + ")",
            style: {
              color: "#47A694",
              fontSize: "14px",
              fontWeight: "bold"
            }
          },
          labels: {
            formatter: function() {
                  return `<span>${this.value}</span>   <b><span style="color: #8C9EFF; font-weight:800">(${counts[this.pos]})</span></b>`
            },
          },
          tickWidth: 2,
          tickmarkPlacement: 'on'
        },
        yAxis: {
          min: 0,
          max: 100,
          gridLineWidth: 0.5,
          title: {
            text: "Share of voice",
            style: {
              color: "#47A694",
              fontSize: "14px",
              fontWeight: "bold"
            }
          },
        },
        tooltip: {
          enabled: true,
          shared: false,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
          formatter: function () {
            let listItems = '';
            for (let item of this.point.tooltip) {
              listItems += `<li><i>${item.key}</i>: <b>${item.value}</b></li><br/>`;
            };

            const ul = `<ul>${listItems}</ul>`;

            return "<b>" + this.point.series.name + ": " + this.point.y + "</b>" + "<br/>" + ul;
          }
        },
        legend: {
          enabled: true,
          alignColumns: true,
          align: "right",
          y: 0,
          x: 0,
          squareSymbol: true,
          verticalAlign: "bottom",
          itemDistance: 20,
          margin: 30,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
          itemMarginTop: 5,
          labelFormatter: function () {
            return `${this.name} <span style="color:#8d8c8c;">(${self.brandCounts[this.name]})</span>`;
          }
        },
        plotOptions: {
          column: {
            stacking: "percent",
            dataLabels: {
              enabled: xAxisData.length > 30 ? false : true,
              useHTML: true,
              zIndex: 0,
              formatter: function () {
                return (
                  '<span style="color:white;font-size:10px;font-weight:bold;padding:4px">' +
                  self.format(Number(this.point.percentage.toFixed())) +
                  "% </span>"
                );
              },
            },
          },
        },
        series: seriesData,
      };
    },
    format(v) {
      return this.$options.filters.format(v);
    },
    getCat() {
      let url = "/api/v2/india_clients/product_price_categories";
      this.loader = true;
      let payload = {
        client: this.customClient,
      };
      this.$http.post(url, payload).then(
        (response) => {
          this.loader = false;
          this.getPriceData();
        },
        (err) => {
          this.loader = false;
          console.log("error");
        }
      );
    },
    refresh() {
      this.updateDisabledDates();
      // this.getCat();
      // this.getPriceData();
    },
  },
};
</script>
<style scoped>
.chartOverflow {
  overflow-x: scroll;
}

.lastUpdated {
  color: #065559;
  text-align: center;
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 5px 12px;
  border: 1px solid var(--base_color-80);
  border-radius: 6px;
  height: 35px;
}

.name {
  line-height: 28px;
  text-transform: capitalize;
  font-size: 14px;
  margin-left: 5px;
}

.value {
  font-size: 14px;
  line-height: 24px;
  margin-right: 5px;
}

.leftsticker {
  width: 65px;
  float: left;
  height: 54px;
  color: white;
  font-size: 37px;
  text-align: center;
}

.rightsticker {
  width: 100%;
  /* float: left; */
  background: white;
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
}

.card {
  margin-bottom: 8px;
}

.card-body {
  padding: 0 !important;
  display: flex;
}

.productwrap {
  padding: 26px;
  padding-top: 6px;
  margin-top: 6px;
}

.grofers_border {
  border-right: 2px solid #f15c2c !important;
}

.tatacliq_border {
  border-right: 2px solid #a9323f !important;
}

.bigbasket_border {
  border-right: 2px solid #83c42a !important;
}

.tatacliq_border {
  border-right: 2px solid #a9323f !important;
}

.amazon_border {
  border-right: 2px solid #ff9900 !important;
}

.croma_border {
  border-right: 2px solid #49a7a1 !important;
}

.paytm_border {
  border-right: 2px solid #28bbf0 !important;
}

.snapdeal_border {
  border-right: 2px solid #f34741 !important;
}

.myntra_border {
  border-right: 2px solid #ec548b !important;
}

.vijaysales_border {
  border-right: 2px solid #ee4326 !important;
}

.ril_border {
  border-right: 2px solid #bfa161 !important;
}

.outofstock {
  color: red;
  float: right;
  font-size: 12px;
  margin-right: 5px;
}

.flipkart_border {
  border-right: 2px solid #2874f0 !important;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  width: 120px !important;
  border: 1px solid var(--base_color-40) !important;
}

.customSelect {
  margin-inline: 0.5rem;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
}

#sovindia4page {
  font-family: "Poppins", sans-serif !important;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show>.btn-outline-secondary.dropdown-toggle {
  color: #ffffff !important;
  background-color: var(--primary_brand-80) !important;
  border-color: var(--primary_brand-80) !important;
  line-height: 35px !important;
  padding: 0px 20px !important;
  border-radius: 5px !important;
  font-weight: 600 !important;
}

.btn-outline-secondary {
  line-height: 35px !important;
  /* border-radius: 5px; */
  color: var(--primary_brand) !important;
  background: var(--primary_brand-10) !important;
  border: 1px solid var(--primary_brand-10) !important;
  font-family: "poppins" !important;
  padding: 0px 20px !important;
}

.btn-group {
  background: var(--primary_brand-10) !important;
  border-radius: 5px !important;
  font-family: "poppins" !important;

  /* border: 1px solid var(--primary_brand-10); */
}

.datePickerBadge {
  margin-left: 6px;
  height: 35px !important;
  border: 1px solid #c5c5c5;
  border-right: none;
  display: flex;
  align-items: center;
  margin-right: -5px;
  z-index: 3;
  background: #fff;
  color: black;
  border-radius: 5px 0px 0px 5px;
  font-family: "poppins";
}

.borderBetween {
  border-bottom: 0.13rem solid #e1e1e1 !important;
  margin: 7px 0px !important;
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.searchInput input {
  height: 35px !important;
  margin-right: -5px !important;
  font-size: 14px !important;
  border-color: var(--primary_brand-60) !important;
  font-family: "poppins";
}

.searchInput input::placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins" !important;
  font-size: 16px !important;
}

.searchInput input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input:focus {
  box-shadow: none !important;
  border-color: var(--primary_brand) !important;
  font-family: "poppins";
}

.searchIcon {
  /* height: 40px; */
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  font-family: "poppins";

  background-color: var(--primary_brand);
}

.searchIcon img {
  width: 25px;
  margin: 10px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

.inputBoxTitle {
  color: var(--primary_brand);
  font-size: 16px;
  margin-bottom: 5px;
  font-family: "poppins";
}

.productListCheckbox span {
  /* font-weight: 600; */
  font-family: "Poppins", sans-serif !important;
}

.eachProduct:hover {
  background: var(--base_color-20);
}
</style>
